module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div id="social_photo_empty">' +
((__t = ( I18n.t('uploader.social.empty_photo') )) == null ? '' : __t) +
'</div>\n<div id="social_photo_loading"></div>\n<div id="social_photo_error" tabindex="0">' +
((__t = ( I18n.t('uploader.social.error') )) == null ? '' : __t) +
'</div>\n<div id="social_photo_wrapper">\n	<div id="social_photo_content"></div>\n	<div id="load_more" tabindex="0">' +
((__t = ( I18n.t('uploader.social.load_more') )) == null ? '' : __t) +
'</div>\n</div>\n<div id="back_albums" class="bottom_button" tabindex="0">' +
((__t = ( I18n.t('uploader.social.back') )) == null ? '' : __t) +
'</div>\n<div id="review_selected" class="bottom_button" tabindex="0">' +
((__t = ( I18n.t('uploader.social.review') )) == null ? '' : __t) +
'</div>';

}
return __p
}